import { render, staticRenderFns } from "./DashbordChat.vue?vue&type=template&id=7ad5906a&"
import script from "./DashbordChat.vue?vue&type=script&lang=js&"
export * from "./DashbordChat.vue?vue&type=script&lang=js&"
import style0 from "./DashbordChat.vue?vue&type=style&index=0&id=7ad5906a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports